module.exports = __webpack_public_path__ + "static/media/objectsGrid-01.3e33594d.jpg";